"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyConvertPolicyTermIntoString = exports.legacyParsePolicyTermFromString = void 0;
var terms_1 = require("./terms");
// these functions should be used to support our current API interface
// that requires the policy term to be a string instead of a number
// until we don't completely decouple from newfront-app
function legacyParsePolicyTermFromString(legacyTerm) {
    if (legacyTerm === 'Other') {
        return null;
    }
    var regexResult = /^[^\d]*(\d+)/.exec(legacyTerm);
    if (!regexResult) {
        return null;
    }
    var months = regexResult[0];
    var monthsNumber = parseInt(months, 10);
    if (Number.isNaN(monthsNumber)) {
        return null;
    }
    return monthsNumber;
}
exports.legacyParsePolicyTermFromString = legacyParsePolicyTermFromString;
function legacyConvertPolicyTermIntoString(policyTermInMonths) {
    if (!policyTermInMonths) {
        return 'Other';
    }
    var policyTerm = terms_1.POLICY_TERMS.find(function (term) { return term.value === policyTermInMonths; });
    if (!policyTerm) {
        throw new Error("Invalid policy term: " + policyTermInMonths);
    }
    return policyTerm.label;
}
exports.legacyConvertPolicyTermIntoString = legacyConvertPolicyTermIntoString;
